/**
 * Adds text next to Video modal icon
 *
 * @since   1.0.0
 * @package veristream
 */
(function($) {

    var $icon = $('#home-banner').find('.pp-trigger-image'),
        text = "See our Check-In Process";

    $icon.after('<span>' + text + '</span>');

})(jQuery);
